/* Evidence first. Every panel remains available when JavaScript is absent. */
(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function init(root = document) {
    root.querySelectorAll('[data-delivery-evidence]:not([data-evidence-ready])').forEach(scene => {
      const buttons = [...scene.querySelectorAll('[data-evidence-view]')];
      const panels = [...scene.querySelectorAll('[data-evidence-panel]')];
      if (!buttons.length || panels.length !== 2) return;
      function select(view) {
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.evidenceView === view)));
        panels.forEach(panel => { panel.hidden = panel.dataset.evidencePanel !== view; });
        scene.dataset.view = view;
      }
      buttons.forEach(button => button.addEventListener('click', () => select(button.dataset.evidenceView)));
      select('photo');
      scene.dataset.evidenceReady = 'true';
      scene.querySelector('.j-delivery-evidence__controls').hidden = false;
    });
    root.querySelectorAll('.j-founders__film:not([data-film-ready])').forEach(details => {
      details.dataset.filmReady = 'true';
      details.addEventListener('toggle', () => {
        if (!details.open) details.querySelector('video')?.pause();
      });
    });
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      if (!reduced.matches) entry.target.classList.add('j-trust-enter');
      observer.unobserve(entry.target);
    });
  }, {threshold: .15}) : null;
  function observe(root = document) {
    root.querySelectorAll('.j-founders__portrait, .j-delivery-evidence, .j-trust-links').forEach(element => observer?.observe(element));
  }
  init(); observe();
  reduced.addEventListener('change', event => {
    if (event.matches) document.querySelectorAll('.j-trust-enter').forEach(element => element.classList.remove('j-trust-enter'));
  });
  document.addEventListener('shopify:section:load', event => { init(event.target); observe(event.target); });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.j-founders__portrait, .j-delivery-evidence, .j-trust-links').forEach(element => observer?.unobserve(element));
  });
})();
